const DEFAULT_C15T_BACKEND_URL = "https://514-ai-dev-fiveonefour.inth.app";

export const C15T_BACKEND_URL =
  process.env.NEXT_PUBLIC_C15T_BACKEND_URL || DEFAULT_C15T_BACKEND_URL;

export const C15T_BROWSER_BACKEND_URL = process.env.NEXT_PUBLIC_C15T_BACKEND_URL || "/c15t";

export const C15T_STORAGE_KEY = "axp-consent";

export const C15T_COOKIE_DOMAIN = process.env.NEXT_PUBLIC_C15T_COOKIE_DOMAIN || undefined;

interface HeaderReader {
  get(name: string): string | null;
}

export function cookieDomainForHostname(
  configuredDomain: string | undefined,
  hostname: string,
): string | undefined {
  const domain = configuredDomain?.trim();
  if (!domain) return undefined;

  const normalizedDomain = domain.replace(/^\./, "");
  return hostname === normalizedDomain || hostname.endsWith(`.${normalizedDomain}`)
    ? domain
    : undefined;
}

export function cookieDomainForRequestHeaders(
  configuredDomain: string | undefined,
  requestHeaders: HeaderReader,
): string | undefined {
  const forwardedHost = requestHeaders.get("x-forwarded-host")?.split(",", 1)[0]?.trim();
  const host = forwardedHost || requestHeaders.get("host")?.trim();
  if (!host) return undefined;

  try {
    return cookieDomainForHostname(configuredDomain, new URL(`https://${host}`).hostname);
  } catch {
    return undefined;
  }
}

export const C15T_CONSENT_CATEGORIES = ["necessary", "measurement", "marketing"] as const;

// Kept accurate as capture moves first-party (ENG-4281): pages viewed and
// in-product actions are now recorded on 514's own servers rather than by a
// third-party analytics SDK, while PostHog still receives product analytics
// for the remainder of the PostHog migration.
export const C15T_MEASUREMENT_DESCRIPTION =
  "Measurement helps us understand product usage. Pages you view and actions you take are recorded on our own servers, and product analytics are also sent to PostHog. The ax_ft cookie stores a random correlation ID, landing page, referrer, UTM source, medium, campaign, term, content, and the first-seen time for up to one year.";

export const C15T_CONSENT_DIALOG_DESCRIPTION =
  "Choose whether we may measure product usage with our own analytics, PostHog, and the ax_ft first-touch cookie. Necessary cookies remain enabled.";
